export const SECTION_TYPE_REQUEST = 'SECTION_TYPE_REQUEST';
export const SECTION_TYPE_SUCCESS = 'SECTION_TYPE_SUCCESS';
export const SECTION_TYPE_FAIL = 'SECTION_TYPE_FAIL';